import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from '@env/environment';
import { IHttpRequestOptions } from '../interfaces/http-request-option.interface';
import { map, Observable } from 'rxjs';
import { TokenService } from './token.service';
import { RefreshTokenName } from '../config/constants';
import { LocalStorageService } from './storage/local-storage.service';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class HttpWrapperService {

  private readonly apiGateWayEndPoint = env.apiUrl;

  constructor(
    private readonly http: HttpClient,
    private readonly tokenService: TokenService,
    private readonly localStorageService: LocalStorageService,
  ) {
  }

  private extractData(res: any, disableNotification?: boolean) {
    if (!res) return null;
    if(res instanceof Blob) return res;
    return res.data;
  }

  getpdf(options: IHttpRequestOptions): Observable<any> {
    this.refreshSession();
    return this.http.get(this.apiGateWayEndPoint + options.url, options)
      .pipe(map((result: any) => {
        return this.extractData(result, options.disableNotification)
      }));
  }

  getFromApiGateWay(options: IHttpRequestOptions): Observable<any> {
    this.refreshSession();
    let params = new HttpParams();
    const url = this.apiGateWayEndPoint + options.url;
    if (options.params) {
      for (const key in options.params) {
        if (Object.prototype.hasOwnProperty.call(options.params, key)) {
          params = params.set(key, options.params[key]);
        }
      }
    }
    return this.http.get(url, { params, transferCache: options.transferCache })
      .pipe(map((result) => {
        return this.extractData(result, options.disableNotification)
      }));
  }

  postFromApiGateWay(options: IHttpRequestOptions): Observable<any> {
    this.refreshSession();
    return this.http.post(this.apiGateWayEndPoint + options.url, options.body, options)
      .pipe(map((result) => {
        return this.extractData(result, options.disableNotification)
      }));
  }

  putFromApiGateWay(options: IHttpRequestOptions): Observable<any> {
    this.refreshSession();
    return this.http.put(this.apiGateWayEndPoint + options.url, options.body, options)
      .pipe(map((result) => {
        return this.extractData(result, options.disableNotification)
      }));
  }

  patchFromApiGateWay(options: IHttpRequestOptions): Observable<any> {
    this.refreshSession();
    return this.http.patch(this.apiGateWayEndPoint + options.url, options.body, options)
      .pipe(map((result) => {
        return this.extractData(result, options.disableNotification)
      }));
  }

  deleteFromApiGateWay(options: IHttpRequestOptions): Observable<any> {
    this.refreshSession();
    return this.http.delete(this.apiGateWayEndPoint + options.url, options)
      .pipe(map((result) => {
        return this.extractData(result, options.disableNotification)
      }));
  }

  uploadApiGatWay(options: IHttpRequestOptions): Observable<any> {
    this.refreshSession();
    return this.http.post(this.apiGateWayEndPoint + options.url, options.body, options)
      .pipe(map((result) => {
        return this.extractData(result, options.disableNotification)
      }));
  }

  refreshTokenAPIcall(): Observable<any> {
    this.tokenService.setRefreshHelper();
    const body = new HttpParams()
     
      .set('grant_type', "refresh_token")
      .set('refresh_token', JSON.parse(this.localStorageService.getData(RefreshTokenName) as string || ''))
    return this.http.post<any>(env.authPath, body, {})
  }

  refreshSession() {
    try {
      this.refreshTokenAPIcall().subscribe({
        next: (token: any) => {
          // CODE HERE
        }, error: (err: any) => {
          // CODE HERE
        }
      });
      // }
    } catch (e) { /* empty */ }
  }

}
